import { Monitor, Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useThemeMode } from '@/hooks/use-theme';

const ORDER = ['system', 'light', 'dark'] as const;

export function ThemeToggle() {
  const { preference, setPreference } = useThemeMode();
  const Icon = preference === 'light' ? Sun : preference === 'dark' ? Moon : Monitor;

  const next = () => {
    const index = ORDER.indexOf(preference);
    const nextPreference = ORDER[(index + 1) % ORDER.length] ?? 'system';
    setPreference(nextPreference);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={next}
          aria-label={`Theme: ${preference}. Click to change.`}
          className="text-muted-foreground hover:text-foreground"
        >
          <Icon className="size-[15px]" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Theme: {preference}</TooltipContent>
    </Tooltip>
  );
}
